module.exports = __webpack_public_path__ + "img/pdfWay.8ce4e0c0.png";